import React from 'react'
import { useTheme } from 'styled-components'

import { SVGFakturaLogoDark, SVGFakturaLogoLight } from '@common/public/assets'
import { ButtonInventory } from '@components/ButtonInventory'
import useMain from '@hooks/useMain'

import 'react-toastify/dist/ReactToastify.css'

import { HeaderContainer, HeaderMenu, HeaderStyled, StyledToast } from './styles'

const Header: React.FC = () => {
    const themeContext = useTheme()

    const isIframe = window.location != window.parent.location
    const {
        state: { currentStep },
        operations: { setShouldWarning, setWarningMessage },
    } = useMain()
    // turn theme backgroundcolor from hex to interger (removing "#")
    // and compare with integer equivalent to "#808080"
    const themeBackgroundToInteger = Number.parseInt('0x' + themeContext.variables.colorBackground.replace('#', ''), 16)
    const darkBackgroundLimiteToInteger = Number.parseInt('0x' + '808080', 16)
    const isBackgroundDark = themeBackgroundToInteger < darkBackgroundLimiteToInteger
    const isNotVisible = currentStep === 'home-multiple-sales-behaviour'

    const handleCloseWarnings = React.useCallback(() => {
        setWarningMessage('')
        setShouldWarning(false)
    }, [setShouldWarning, setWarningMessage])

    const CloseButton = ({ closeToast }: any) => {
        const clickedToClose = document.querySelectorAll('.close-button')[0]
        if (clickedToClose) {
            clickedToClose.addEventListener('click', function () {
                handleCloseWarnings()
            })
        }
        return (
            <button className="close-button" onClick={closeToast} type="button">
                Try again
            </button>
        )
    }

    return (
        <HeaderStyled>
            <StyledToast
                autoClose={false}
                closeButton={<CloseButton />}
                closeOnClick={false}
                draggable
                pauseOnHover
                newestOnTop
                pauseOnFocusLoss={false}
            />
            <HeaderContainer isNotVisible={isNotVisible} isIframe={isIframe}>
                {isBackgroundDark ? <SVGFakturaLogoLight /> : <SVGFakturaLogoDark />}
            </HeaderContainer>
            <HeaderMenu>
                <div></div>
                <div></div>
                <div>
                    <ButtonInventory />
                </div>
            </HeaderMenu>
        </HeaderStyled>
    )
}

export default Header
